import { getCompatibleVersions } from 'baseline-browser-mapping';
import Bowser from 'bowser';

import { isBrowser } from './isBrowser';

const BROWSER_NAME_MAP: Record<string, string> = {
    'microsoft edge': 'edge',
};

const normalizeBrowserName = (name: string): string => {
    const nameInLowerCase = name.toLowerCase();

    return BROWSER_NAME_MAP[nameInLowerCase] ?? nameInLowerCase;
};

export const isBrowserSupported = (): boolean => {
    if (!isBrowser()) {
        return false;
    }

    const userAgent = window.navigator.userAgent;
    if (!userAgent) {
        return false;
    }

    const parser = Bowser.getParser(userAgent);
    const browserName = parser.getBrowserName();
    const browserVersion = parser.getBrowserVersion();

    if (!browserName || !browserVersion) {
        return false;
    }

    const compatibleVersions = getCompatibleVersions({
        targetYear: 2024,
    });

    return compatibleVersions.some(
        (browserInfo) =>
            browserInfo.browser === normalizeBrowserName(browserName) &&
            Number(browserInfo.version) < parseInt(browserVersion, 10),
    );
};
